module.exports = __webpack_public_path__ + "img/logo.defc4f1f.png";